/**
 * Componente Molecule para selección de modo de chat en el Inbox.
 *
 * Permite al usuario seleccionar el modo de chat activo mediante un menú desplegable optimizado y estilizado con TailwindCSS.
 * Utiliza el patrón de composición atómica (Molecule) y está optimizado con React.memo para evitar renders innecesarios.
 */
import React, { memo } from "react";
import DropdownButton from "../../../components/DropdownButtonMC";
import useChatModeDropdownUI from "../../../hooks/inbox/ui/useChatModeDropdownUI";

/**
 * ChatModeDropdownMC - Componente para selección de modo de chat en el Inbox.
 */
const ChatModeDropdownMC = memo(({ selectedChatMode, handleToggleChatMode }) => {
  const { chatModeOptions, selectedLabelChatMode } = useChatModeDropdownUI(selectedChatMode, handleToggleChatMode);

  return (
    <div className="tw-mt-0 tw-flex tw-items-center tw-gap-1 tw-justify-start">
      <DropdownButton
        dropUp
        variant="TEXT_PLAIN"
        text={selectedLabelChatMode}
        items={chatModeOptions}
        dropdownClassName="tw-min-w-[200px] tw-max-w-[400px] tw-left-0"
        className="!tw-ml-0.5 !tw-text-default !tw-text-blue-500 !txt-font-medium !tw-h-full !tw-min-h-0 !tw-py-0 !tw-px-2 !tw-bg-gray-50"
      />
    </div>
  );
});

ChatModeDropdownMC.displayName = "ChatModeDropdownMC";

export default ChatModeDropdownMC;
